module.exports = __webpack_public_path__ + "img/sensor_clear.cce28f2f.png";